type ShouldAutoOpenMarketSettings = {
    isMarketSettingAutoDisplayEnabled: boolean;
    isBuyer: boolean;
    hasDepartmentIdUnfilledOut: boolean;
    isBrandUser: boolean;
    isKindOfStatusThatShouldOpen: boolean;
};

export const shouldAutoOpenMarketSettings = ({
    hasDepartmentIdUnfilledOut,
    isBrandUser,
    isBuyer,
    isKindOfStatusThatShouldOpen,
    isMarketSettingAutoDisplayEnabled,
}: ShouldAutoOpenMarketSettings) =>
    isMarketSettingAutoDisplayEnabled &&
    ((isBuyer && hasDepartmentIdUnfilledOut) || (isBrandUser && isKindOfStatusThatShouldOpen));
